export default {
  menuClickControlModalData: {},
  catalogModalDeleteRowId: null,
  wmsAgreementModalData: {
    open: false,
    contractContent: null,
    redirectHref: '/supplies-management',
  },
};
